/*
 * @Description:
 * @Author: lizhenglin
 * @Date: 2022-06-28 10:28:29
 * @LastEditors: lizhenglin
 * @LastEditTime: 2022-06-28 10:28:43
 */
import Vue from "vue";
import Vant from "vant";
import "vant/lib/index.less";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import VueResource from "vue-resource";
// import echarts from 'echarts';
import common from "./providers/common";
import Api from "./providers/api";
import App from "./app.vue";
import store from "./store";

import router from "./router.js";
import VideoPlayer from "vue-video-player";
import "vue-video-player/src/custom-theme.css";
import "video.js/dist/video-js.css";
import Vconsole from "vconsole";
import waterfall from "vue-waterfall2";

new Vconsole(); //别动！别动！别动！！！！！！！！！！！！！！！

// new Vconsole();

//设置title
import VueWechatTitle from "vue-wechat-title";

Vue.config.ignoredElements = ["wx-open-launch-weapp", "wx-open-launch-app"];

Vue.config.productionTip = false;
Vue.use(Vant);

import { Lazyload } from "vant";
Vue.use(Lazyload);

Vue.use(VueAwesomeSwiper);
Vue.use(VueResource);
// Vue.prototype.echarts = echarts;
Vue.use(common);
Vue.use(Api);
Vue.use(VueWechatTitle);

Vue.use(waterfall);

Vue.use(VideoPlayer);

import "dsbridge";

// new Vue({
//   render: h => h('router-view'),
//   router,
//   store
// }).$mount('#app')

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
